import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconEye = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.5 13.125C10.875 13.125 13.5 10.2188 14.625 8.53125C15.0938 7.875 15.0938 7.03125 14.625 6.375C13.5 4.78125 10.875 1.875 7.5 1.875C4.125 1.875 1.5 4.78125 0.375 6.46875C-0.09375 7.125 -0.09375 7.96875 0.375 8.53125C1.5 10.2188 4.125 13.125 7.5 13.125ZM7.5 4.6875C9.09375 4.6875 10.3125 5.90625 10.3125 7.5C10.3125 9.09375 9.09375 10.3125 7.5 10.3125C5.90625 10.3125 4.6875 9.09375 4.6875 7.5C4.6875 5.90625 5.90625 4.6875 7.5 4.6875Z",
		fill: "currentColor"
	})
});
export default SvgIconEye;
